import React from 'react';
import { Row, Col, Card } from 'antd';
import { SafetyOutlined, ThunderboltOutlined, DatabaseOutlined, PhoneOutlined } from '@ant-design/icons';

function AboutUs() {
    const highlights = [
        {
            icon: <ThunderboltOutlined />,
            title: 'Rapid Repairs',
            description: 'Most repairs in store including iPhone screen repair take just 20-30 minutes!'
        },
        {
            icon: <SafetyOutlined />,
            title: 'FREE Diagnostics, No Fix No Fee',
            description: 'If we can\'t fix your device we do not charge and we offer FREE phone diagnostics'
        },
        {
            icon: <DatabaseOutlined />,
            title: 'Your Data Is Safe',
            description: 'We will never wipe your data unless absolutely necessary for repair and only with your consent'
        },
        {
            icon: <PhoneOutlined />,
            title: 'Free Phone Diagnostics',
            description: 'We do not charge to diagnose phone problems!'
        }
    ];

    return (
        <div className="about-us-container">
            {/* Hero Section */}
            <section className="about-hero">
                <div className="about-hero-content">
                    <h1>About Us</h1>
                    <p className="hero-lead">Ireland's Trusted Tech Repair Experts Since 2011</p>
                </div>
            </section>

            {/* Main Content */}
            <section className="about-content">
                <div className="container">
                    <Row gutter={[48, 48]}>
                        <Col xs={24} lg={16}>
                            <div className="about-text">
                                <h2>Our Story</h2>
                                <p>
                                    E-Tech was founded in April 2011 and the first tech repair centre opened in Dundrum. 
                                    Our goal is to provide the highest level of service to our customers and ensure every 
                                    customer who uses us is a satisfied one.
                                </p>
                                <p>
                                    As the smartphone and computer markets continue to grow rapidly so does the need to 
                                    repair these products. iPhones, tablets and computers are crucial to most people's daily 
                                    lives and it is our mission to make sure we have these important devices back working 
                                    for our customers as quickly as possible.
                                </p>
                                <p>
                                    iPhone repair in Dublin is becoming an increasingly sought after service and we here at 
                                    E-Tech are delighted to be able to offer this at the highest level to our customers and 
                                    back up all of our repair work with a 3 month repair warranty for peace of mind.
                                </p>
                                <p>
                                    To ensure the highest quality repairs for our customers we only use the best quality 
                                    replacement parts available to us and the very best technicians in the business!
                                </p>
                                <p className="highlight-text">
                                    If our technicians can't repair your phone, tablet or computer, nobody can!
                                </p>
                                <p>
                                    We take great pride in our service and this will show if you provide us the opportunity.
                                </p>
                            </div>
                        </Col>
                        <Col xs={24} lg={8}>
                            <Card className="ceo-card">
                                <div className="ceo-content">
                                    <p className="ceo-message">
                                        "Thank you for taking the time to read about us and hopefully we see you soon!"
                                    </p>
                                    <div className="ceo-signature">
                                        <strong>Eddie Peng</strong>
                                        <span>E-Tech CEO</span>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </section>

            {/* Highlights Section */}
            <section className="about-highlights">
                <div className="container">
                    <h2 className="section-title">Why Choose E-Tech?</h2>
                    <Row gutter={[32, 32]}>
                        {highlights.map((item, index) => (
                            <Col xs={24} sm={12} md={6} key={index}>
                                <Card className="highlight-card" bordered={false}>
                                    <div className="highlight-icon">{item.icon}</div>
                                    <h3>{item.title}</h3>
                                    <p>{item.description}</p>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </div>
            </section>
        </div>
    );
}
export default AboutUs;
